// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f5f09f10","239":"18d71e96","453":"c633a191","455":"c2861a94"}[chunkId] + ".chunk.js";
};